import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';
import Link from 'antd/es/typography/Link';
import { ImageWithPreview } from '@/components';

export const StyledTitleWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;

  &&& svg {
    transform: scale(0.75);
  }

  @media screen and ${DEVICES.LAPTOP_S} {
    &&& svg {
      transform: scale(1);
    }
  }
`;

export const StyledTitle = styled.div`
  text-transform: uppercase;
  ${pickThemeFontStyles('12', '12', 'NORMAL')};
  color: ${COLORS.BLACK_PRIMARY};

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('16', '16', 'NORMAL')};
  }
`;

export const StyledTopProductsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const StyledItem = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;

export const StyledItemTitle = styled.div`
  ${pickThemeFontStyles('16', '24', 'NORMAL')};
  color: ${COLORS.CHARCOAL};
`;

export const StyledItemContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1.25rem;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid ${COLORS.BRIGHT_GRAY};

  @media screen and ${DEVICES.LAPTOP_L} {
    flex-direction: row;
  }
`;

export const StyledUrl = styled(Link)`
  &&& {
    cursor: pointer;
    text-decoration: underline;
    display: block;
    max-width: 11rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const StyledItemCover = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 7.25rem;
  height: 7.25rem;
  overflow: hidden;
  background: ${COLORS.GRAY_LIGHT};

  @media screen and ${DEVICES.DESKTOP} {
    width: 8.875rem;
    height: 8.875rem;
  }
`;

export const StyledImage = styled(ImageWithPreview)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const StyledItemActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  &&& button {
    font-size: 0.75rem;
  }
`;
